import { useState, useEffect } from "react";
import { css } from "@emotion/css";
import { Item } from "../components";
import {
  getReleasedBooks,
  getUpcomingBooks,
  getAuthorForBook,
  getTypes,
} from "../common";

export const Books = () => {
  const [releasedBooks, setReleasedBooks] = useState([]);
  const [upcomingBooks, setUpcomingBooks] = useState([]);
  const cssHeader = css`
    font-family: Playfair Display;
    font-size: 2rem;
    font-weight: 700;
    color: var(--dark-grey);
  `;

  useEffect(() => {
    getReleasedBooks().then((books) =>
      setReleasedBooks(
        books.sort((a, b) =>
          a.name.localeCompare(b.name, "sv", { sensitivity: "base" }),
        ),
      ),
    );
  }, []);

  useEffect(() => {
    getUpcomingBooks().then((books) => {
      setUpcomingBooks(
        books.sort((a, b) =>
          a.name.localeCompare(b.name, "sv", { sensitivity: "base" }),
        ),
      );
    });
  }, []);

  return (
    <div
      className={css`
        margin-top: 1rem;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        text-align: left;
      `}
    >
      {releasedBooks.length > 0 && (
        <>
          <div className={cssHeader}>Utgivna böcker</div>
          {releasedBooks.map((book, index) => (
            <Book key={index} book={book} />
          ))}
        </>
      )}

      <br />
      <br />

      {upcomingBooks.length > 0 && (
        <>
          <div className={cssHeader}>Kommande böcker</div>
          {upcomingBooks.map((book, index) => (
            <Book key={index} book={book} />
          ))}
        </>
      )}
    </div>
  );
};

const Book = ({ book }) => {
  const [author, setAuthor] = useState();
  const [type, setType] = useState();

  useEffect(() => {
    getAuthorForBook(book.key).then((author) => setAuthor(author));
  }, [book.key]);

  useEffect(() => {
    getTypes().then((types) =>
      setType(types.find((type) => type.value === book.type)),
    );
  }, [book.type]);

  return (
    <Item
      type="book"
      imgSrc={book.cover}
      name={book.name}
      about={book.info}
      bookInfo={{
        author: author?.name,
        illustrator: book.illustrator,
        pages: book.pages,
        type: type?.label,
        releaseDate: book.releaseDate,
        ISBN: book.ISBN,
      }}
    />
  );
};
